var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"qw-layout"},[_c('Navbar'),_c('div',{staticClass:"qw-layout__page"},[_c('AppMain')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }